import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  mainContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Theme.palette.gray[50],
  },
  contentContainer: {
    maxWidth: 1080,
    margin: '0 auto',
    flex: '1 0 auto',
    boxSizing: 'border-box',
    width: '100%',
    [Theme.breakpoints.up('xl')]: {
      width: '100%',
    },
    [Theme.breakpoints.down('lg')]: {
      padding: '0 50px',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '0 20px',
    },
    '& h1': {
      [Theme.breakpoints.down('sm')]: {
        fontSize: Theme.typography.size[6],
        lineHeight: Theme.typography.size[9],
      },
    },
  },
  pageSection: {
    paddingRight: 0,
    paddingLeft: 0,
    [Theme.breakpoints.down('sm')]: {
      paddingTop: 30,
    },
  },
  browseFooter: {
    width: 'auto',
    flexShrink: '0',
  },
  goReservation: {
    float: 'right',
    marginRight: '0',
    marginTop: 30,
    fontSize: Theme.typography.size[1],
    lineHeight: Theme.typography.size[3],
  },
}));

export default useStyles;
